module.exports = __webpack_public_path__ + "static/media/link-symbol.1ae68aa9.svg";